import { render, staticRenderFns } from "./left_side.vue?vue&type=template&id=a40faf80&scoped=true&"
import script from "./left_side.vue?vue&type=script&lang=js&"
export * from "./left_side.vue?vue&type=script&lang=js&"
import style0 from "./left_side.vue?vue&type=style&index=0&id=a40faf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40faf80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a40faf80')) {
      api.createRecord('a40faf80', component.options)
    } else {
      api.reload('a40faf80', component.options)
    }
    module.hot.accept("./left_side.vue?vue&type=template&id=a40faf80&scoped=true&", function () {
      api.rerender('a40faf80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/list/left_side.vue"
export default component.exports